import { render } from "./ChildModal.vue?vue&type=template&id=4c48f049&scoped=true"
import script from "./ChildModal.vue?vue&type=script&lang=js"
export * from "./ChildModal.vue?vue&type=script&lang=js"

import "./ChildModal.vue?vue&type=style&index=0&id=4c48f049&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c48f049"]])

export default __exports__